import { EmpathizeState } from '../../../models';
import { EMPATHIZE_MUTATIONS_KEYS } from '../empathize.const';
import { EmpathizeMutation } from '../empathize.interfaces';

export class ClearEmpathizeStateMutation implements EmpathizeMutation {
  mutations = {
    [EMPATHIZE_MUTATIONS_KEYS.clearEmpathizeState]: (localState: EmpathizeState) => {
      localState.termSuggestions = [];
      localState.selectedIndex = -1;
    }
  };
}
